import React, { useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import bemCn from 'bem-cn';
import SvgCross2 from 'src/assets/svg/SvgCross2.svg';
import './index.scss';

const b = bemCn('modal-mobile');

const ModalMobile = ({
    isBlur = false,
    isCentered = false,
    isOpen = false,
    toggle,
    title = '',
    children,
    className = '',
    resetFilter,
    resetFilterText = 'Reset all',
    contentClassName = '',
    onReset = () => {},
}) => {
    const timeout = { timeout: 100 };

    useEffect(() => {
        if (!isOpen) {
            const bodyEle = document.querySelector('body');
            setTimeout(() => {
                bodyEle.style.overflow = '';
            }, 120);
        }
    }, [isOpen]);

    return (
        <Modal
            centered={isCentered}
            isOpen={Boolean(isOpen)}
            toggle={toggle}
            className={`${b()} ${className}`}
            backdropTransition={timeout}
            modalTransition={timeout}
            modalClassName={`modal-mobile-wrapper ${isBlur ? 'modal-mobile-blur' : ''}`}
            contentClassName={contentClassName}
        >
            <ModalBody>
                {title && (
                    <div className={b('title')}>
                        <p className="snif-s1 snif-regular mb-0">
                            <span className="text">{title}</span>
                            <SvgCross2 className={b('close-button', { resetFilter })} onClick={toggle} />
                            <span className={b('rectangle-mobile')} />
                            {resetFilter && (
                                <span className="snif-s2 snif-medium reset-all" onClick={onReset}>
                                    {resetFilterText}
                                </span>
                            )}
                        </p>
                    </div>
                )}
                <div className={b('content')}>{children}</div>
            </ModalBody>
        </Modal>
    );
};

export default ModalMobile;
